module.exports = __webpack_public_path__ + "static/scale-model-of-air-sea-travel-&-tours-in-pearland-texas-89db3850d740c631c28894c315f02ac7.png";